import Cookies from "js-cookie";

export type FmsVersions = "active" | "pending";

export const isProductionHostname = (): boolean => {
  const { hostname } = window.location;
  return /^(www2|www|investor)\.(intra\.|partners\.)?storebrand\.no$|^pr\.stb\.intra$/.test(
    hostname,
  );
};

function getVersionFromWindowLocation(): FmsVersions {
  if (isProductionHostname()) {
    return "active";
  }

  return "pending";
}

export function getVersion(): FmsVersions {
  const versionFromIwaCli = window.env?.TRANSLATION_VERSION;
  if (versionFromIwaCli) {
    return versionFromIwaCli;
  }

  return getVersionFromWindowLocation();
}

/* istanbul ignore next */
export function getInitialLanguage(): string {
  const language = Cookies.get("lang");
  return language || "no";
}

/* istanbul ignore next */
export function getCookieDomain(): string {
  return process.env.NODE_ENV === "development"
    ? location.hostname // eslint-disable-line
    : ".storebrand.no";
}
